import { ActionHandler } from "../../../common/actions/core/action-handler";
import { Action } from "../../../common/actions/core/action";
import {OpenStudentQuotaAction} from "./quota-exceeded.action";
import { UserResponse } from "../../../common/services/user/user.model";
import GlobalSpinnerService from "../../../common/services/spinner/global-spinner.service";
import UserService from "../../../common/services/user/user.service";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";

/*@ngInject*/
export default class QuotaExceededController implements ActionHandler{
  protected user: UserResponse;
  protected dialogElement;

  constructor(
    protected $element,
    protected actionDispatcher: ActionDispatcherService,
    protected globalSpinner: GlobalSpinnerService,
    protected userService: UserService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element.find('#student-plan-application-quota-exceeded-modal').remodal();
    this.actionDispatcher.register(this);
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }
  public handle(action: Action) {
    if (action instanceof OpenStudentQuotaAction) {
      this.handleDialogAction(action);
    }
  }

  protected handleDialogAction(action: OpenStudentQuotaAction) {

    this.globalSpinner.start();
    this.userService.getUserInfo()
      .then(data => {
        this.user = data;
        this.openDialog();
      })
      .finally(() => {
        this.globalSpinner.stop();
      });
  }

  public onCancel() {
    this.close();
  }

  private openDialog() {
    this.dialogElement.open();
  }

  private close() {
    this.dialogElement.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/student/quota-exceeded/quota-exceeded.controller.ts